<template>
  <transition
    enter-active-class="transition ease-out duration-200"
    enter-from-class="transform opacity-0 scale-95"
    enter-to-class="transform opacity-100 scale-100"
    leave-active-class="transition ease-in duration-200"
    leave-from-class="transform opacity-100 scale-100"
    leave-to-class="transform opacity-0 scale-95"
    mode="out-in"
  >
    <div v-if="!isLoaded" class="w-full h-full absolute inset-0 z-50">
      <img src="/images/view-mock.jpg" class="w-full h-full object-cover" alt="">
      <div class="w-full h-full absolute inset-0 flex justify-center items-center px-10">
        <div class="w-full bg-white shadow p-10 border rounded-md max-w-md">
          <div class="flex justify-between mb-1">
            <span class="text-base font-medium text-primary-700 dark:text-white">Loading</span>
            <span class="text-sm font-medium text-primary-700 dark:text-white">{{ progress }}%</span>
          </div>
          <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
            <div class="bg-primary-600 h-2.5 rounded-full" :style="`width: ${progress}%;`" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
defineProps({
  isLoaded: {
    type: Boolean,
    default: false
  },
  progress: {
    type: Number,
    default: 0
  }
});
</script>
